import React from "react";
import styled, { css } from "styled-components";
import Modal from "components/Modal";

const ModalBody = styled.div``;

const ModalDesc = styled.div`
  text-align: center;
  padding: 12px 0;
  font-size: 16px;
`;

const ConfirmButtonGroup = styled.div`
  display: flex;
`;
const ConfirmButton = styled.div`
  flex: 1;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 18px;
  height: 50px;
  color: #e94f1f;

  ${({ cancel }) =>
    cancel &&
    css`
      color: #202020;
    `}
`;
function ConfirmModal({
  description,
  onConfirmText,
  onConfirm,
  onCancelText,
  onCancel,
}) {
  return (
    <Modal className="modal-center">
      <ModalBody>
        <ModalDesc>{description}</ModalDesc>
        <ConfirmButtonGroup>
          {onCancelText && (
            <ConfirmButton cancel type="button" onClick={onCancel}>
              {onCancelText}
            </ConfirmButton>
          )}
          {onConfirmText && (
            <ConfirmButton type="button" onClick={onConfirm}>
              {onConfirmText}
            </ConfirmButton>
          )}
        </ConfirmButtonGroup>
      </ModalBody>
    </Modal>
  );
}

export default ConfirmModal;
